import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;
const emailcontent  = "<script>alert('Email XSS')</script>";
const entityAddress = "<div onclick='alert(\"XSS\")'>Click me</div>";
const customcontent = "<span style='color:red'>This is red</span>";


export const PassPortCheck = (document) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.post(apiUrl + "ocr/passport", {
        document
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
            // 'Content-Type': 'application/json',
            // "api-key": apiKey,
            // "account-id": accountId
        }
    });
};

// FOR MULTIPLE FILE SENT TIME WORK THIS
// export const PassPortCheck = (document, document2) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//         throw new Error("Authentication token not found.");
//     }
//     const formData = new FormData();
//     formData.append('document', document);
//     if (document2) formData.append('document2', document2);
//     return axios.post(apiUrl + "ocr/passport", {
//         document,document2
//     }, {
//         headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//             // 'Content-Type': 'application/json',
//             // "api-key": apiKey,
//             // "account-id": accountId
//         }
//     });
// };

export const AddApplicantDetails = (form_id, booking_id, noapplicant, applicants) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.post(apiUrl + "response", {
        applicants,
        booking_id,
        noapplicant,
        form_id
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    });
};

export const AddNewApplicantDetails = (form_id, booking_id, noapplicant, applicants) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.post(apiUrl + "response/store-applicant", {
        applicants,
        booking_id,
        noapplicant,
        form_id
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    });
};

export const GetFormApplicant = (entity_id) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.get(apiUrl + `forms/${entity_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const GetApplicantData = (applicant_id) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.get(apiUrl + `response/applicant/${applicant_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const GetVisaCategories = () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
        throw new Error("Authentication token not found.");
    }
    return axios.get(apiUrl + 'visacategories', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};


export const UpdateApplicantDetails = (applicantId, data) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    throw new Error("Authentication token not found.");
  }

  return axios.put(apiUrl + `response/${applicantId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`
      // 'Content-Type': 'application/json', // Optional, Axios sets it automatically
    }
  });
};

export const UpdatePendingApplicantDetails = (payload) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    throw new Error("Authentication token not found.");
  }

  return axios.post(apiUrl + `booking/upload-attachment`, payload, {
    headers: {
      Authorization: `Bearer ${token}`
      // 'Content-Type': 'application/json', // Optional, Axios sets it automatically
    }
  });
};



